import {Message} from "element-ui";

export const alert = (message, opt = {})  => {
  return Message(Object.assign({type: 'error', message: message, showClose: true}, opt) as any);
};
